import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import EaHeader from '@components/ea/EaHeader';
import EaBottom from '@components/ea/EaBottom';

import SatCheckBox from '@components/common/satUI/SatCheckBox';
import SatSelect from '@components/common/satUI/SatSelect';
import SatRadio from '@components/common/satUI/SatRadio';
import SatFollowText from '@components/common/satUI/SatFollowText';
import SatDatePicker from '@components/common/satUI/SatDatePicker';
import SatInput from '@components/common/satUI/SatInput';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';
import { addDates, getToday, isBeforeDay } from '@common/utils/date';
import { parse } from 'date-fns';
import {
  FP_REPORT_RECRUIT_PATH_LIST,
  FP_REPORT_RECRUIT_SELECT_LIST,
} from '@common/constants';

const AppReportInterview = props => {
  const {
    onClickConfirmBtn,
    fpReport,
    subscriptionDate,
    onChangeFpReport,
    ownerName,
    complete,
    isCheckList,
    userType,
    omniYn,
    isRewrite = false,
  } = props;

  const followRef = useRef();
  const placeInputRef = useRef();
  const [isValid, setIsValid] = useState(false); // 따라쓰기 입력 여부
  const [isConfirm, setIsConfirm] = useState(false); // 확인버튼 Disabled
  const [isCheckError, setIsCheckError] = useState(false); // 에러버튼
  const { channelInfo } = useSelector(state => state.userReducer);

  // 확인버튼 클릭 후 Validation 체크
  const checkIsValidBtn = () => {
    if (isConfirm) {
      if (
        !fpReport.interview.owner.interviewDate &&
        !(omniYn === 'Y' && $utils.checkLPText(userType))
      ) {
        onChangeFpReport('interview', 'interviewDate', subscriptionDate); // 대면일자 변경 안하고 작성완료 할때 default : 청약일
      }
      if (isRewrite) {
        onClickConfirmBtn($utils.checkLPText(userType) ? 'lastPage' : '');
      } else {
        onClickConfirmBtn(
          !isCheckList && $utils.checkLPText(userType) ? 'lastPage' : '',
        );
      }
    } else {
      if (
        fpReport.recruitment.moPath === '' ||
        fpReport.recruitment.moType === '' ||
        fpReport.satLpReport.sns.useSns === '' ||
        fpReport.satLpReport.sns.snsType === '' ||
        fpReport.satLpReport.joinMotivation.length === 0 ||
        fpReport.satLpReport.recommend === '' ||
        fpReport.satLpReport.salesMarket === '' ||
        fpReport.satLpReport.activity.ap === '' ||
        fpReport.satLpReport.activity.pr === '' ||
        // fpReport.satLpReport.difficulty === '' ||
        fpReport.satLpReport.salary === '' ||
        fpReport.satLpReport.family.marriage === '' ||
        fpReport.satLpReport.family.child === '' ||
        !followRef.current.getIsMatched()
        // || fpReport.interview.owner.interviewDate === ''
      ) {
        setIsCheckError(true);
      }

      if (
        fpReport.interview.owner.interviewPlace === '' &&
        !(omniYn === 'Y' && $utils.checkLPText(userType)) // 옴니이고 lp는 면담정보 비활성화
      ) {
        placeInputRef.current.isValidCheck();
      }
    }
  };

  // 따라쓰기 onChange
  const handleMatched = res => {
    if (res) {
      setIsValid(true);
      // interviewName 값 넣어달라는 요청에 의해 추가
      onChangeFpReport('interview', 'interviewName', ownerName);
    }
  };

  const motivateList = () => [
    {
      label: $utils.checkLP(channelInfo.cdVal)
        ? '라이프파트너의 권유'
        : '보험설계사의 권유',
      value: 'Life Planner의 권유',
    },
    { label: 'Annual Review', value: 'Annual Review' },
    { label: '보장에 대한 기본 니즈충족', value: '보장에 대한 기본 니즈충족' },
    {
      label: '상품변경/신상품(특약) 출시',
      value: '상품변경/신상품(특약) 출시',
    },
    { label: '주식시장 등 외부변화', value: '주식시장 등 외부변화' },
    { label: '고객의 자발적 요청', value: '고객의 자발적 요청' },
    {
      label: '결혼/승진/출산 등 신상변화',
      value: '결혼/승진/출산 등 신상변화',
    },
    { label: '기타', value: '기타' },
  ];

  // const difficultyList = [
  //   { label: '회사에 대한 낮은 지명도', value: '회사에 대한 낮은 지명도' },
  //   { label: '보험에 대한 거부감', value: '보험에 대한 거부감' },
  //   { label: '저축기능의 약화', value: '저축기능의 약화' },
  //   { label: '납입능력', value: '납입능력' },
  //   { label: '외국사에 대한 부담감', value: '외국사에 대한 부담감' },
  //   { label: '특약상품의 미흡', value: '특약상품의 미흡' },
  // ];

  const salaryList = [
    { label: '소득없음 (학생, 주부 등)', value: '소득없음 (학생, 주부 등)' },
    { label: '2,000만원대 미만', value: '2,000만원대 미만' },
    { label: '2,000만원대', value: '2,000만원대' },
    { label: '3,000만원대', value: '3,000만원대' },
    { label: '4,000만원대', value: '4,000만원대' },
    { label: '5,000만원대', value: '5,000만원대' },
    { label: '6,000만원대', value: '6,000만원대' },
    { label: '7,000만원대', value: '7,000만원대' },
    { label: '8,000만원대', value: '8,000만원대' },
    { label: '9,000만원대', value: '9,000만원대' },
    { label: '1억원대 이상', value: '1억원대 이상' },
  ];

  useEffect(() => {
    if (complete) {
      setIsConfirm(true);
    } else {
      const {
        recruitment,
        satLpReport: {
          joinMotivation,
          sns,
          recommend,
          salesMarket,
          activity,
          // difficulty,
          salary,
          family,
        },
        interview: { owner },
      } = fpReport;

      if ($utils.checkLPText(userType)) {
        if (
          !recruitment?.moPath ||
          (recruitment.moPath === '소개' && !recruitment?.moType) ||
          // !sns?.useSns ||
          // (sns.useSns === '활용' && !sns?.snsType) ||
          // joinMotivation.length === 0 ||
          // recommend === '' ||
          // salesMarket === '' ||
          // !activity?.ap ||
          // !activity?.pr ||
          // difficulty === '' ||
          // salary === '' ||
          // !family?.marriage ||
          // (family.marriage === '기혼' && !family?.child) ||
          (omniYn !== 'Y' && !isValid) ||
          // !owner?.interviewDate ||
          (omniYn !== 'Y' && !owner?.interviewPlace) // lp 옴니는 면담정보 비활성화
        ) {
          setIsConfirm(false);
        } else {
          setIsConfirm(true);
        }
      } else {
        if (
          !recruitment?.moPath ||
          (recruitment.moPath === '소개' && !recruitment?.moType)
        ) {
          setIsConfirm(false);
        } else {
          setIsConfirm(true);
        }
      }
    }
  }, [fpReport, complete, isValid]);

  return (
    <>
      <EaHeader
        title={
          !$utils.checkLPText(userType)
            ? `1.보험설계사 보고서${isRewrite ? ' (재작성)' : ''} - 모집경로`
            : `1.라이프파트너 보고서${
                isRewrite ? ' (재작성)' : ''
              } - 모집경로 및 면담정보`
        }
      />
      <div className="con-wrap bg-gray">
        <div className="app-wrap">
          <div className="app-box">
            <h2 className="tit-con">{`${
              !$utils.checkLPText(userType)
                ? '모집경로'
                : '모집시 주요사항 및 면담정보'
            }`}</h2>
            {/* 1번 항목*/}
            <div className="infor-list">
              <div className="insu-box">
                <div className="txt-question">
                  <p>
                    {`${
                      $utils.checkLPText(userType) ? '1.' : ''
                    } 모집경로(개인정보 취득 경로)를 다음 사항 중 한가지를
                    반드시 선택해주세요.`}
                  </p>
                  <SatValidationErrMsg
                    visible={
                      isCheckError &&
                      (fpReport.recruitment.moPath === '' ||
                        (fpReport.recruitment.moPath === '소개' &&
                          fpReport.recruitment.moType === ''))
                    }
                    type="error"
                    message="내용을 확인하고 선택해 주세요"
                  />
                </div>
              </div>
              <div className="check-box w100">
                <SatCheckBox
                  checkOne
                  value={[fpReport.recruitment.moPath]}
                  options={FP_REPORT_RECRUIT_PATH_LIST}
                  onChange={value =>
                    onChangeFpReport('recruitment', 'moPath', value[0].value)
                  }
                />
              </div>
              <SatSelect
                value={fpReport.recruitment.moType}
                title="소개자 선택"
                options={FP_REPORT_RECRUIT_SELECT_LIST}
                disabled={fpReport.recruitment.moPath !== '소개'} // 소개 선택시에만 소객자 선택 활성화
                onChange={value =>
                  onChangeFpReport('recruitment', 'moType', value.value)
                }
                customStyleClass="w-200 mgb-16"
              />
            </div>
            {$utils.checkLPText(userType) && (
              <>
                {/* 2번 항목*/}
                {/* <div className="infor-list">
                  <div className="insu-box">
                    <div className="txt-question">
                      <p>{`2. Sales Process상 SNS 활용여부에 대해서 선택해주세요.`}</p>
                      <SatValidationErrMsg
                        visible={
                          isCheckError && fpReport.satLpReport.sns.useSns === ''
                        }
                        type="error"
                        message="내용을 확인하고 선택해 주세요"
                      />
                    </div>
                  </div>
                  <div className="check-box w100">
                    <SatRadio
                      name="useSns"
                      checkOne
                      value={fpReport.satLpReport.sns.useSns}
                      options={[
                        { label: '미활용', value: '미활용' },
                        { label: '활용', value: '활용' },
                      ]}
                      onChange={value =>
                        onChangeFpReport('satLpReport', 'useSns', value.value)
                      }
                    />
                  </div>
                  {fpReport.satLpReport.sns.useSns === '활용' && (
                    <>
                      <div className="insu-box">
                        <div className="txt-question">
                          <p>{`2-1. SNS 활용 상세내용을 선택해주세요.`}</p>
                          <SatValidationErrMsg
                            visible={
                              isCheckError &&
                              fpReport.satLpReport.sns.useSns &&
                              fpReport.satLpReport.sns.snsType === ''
                            }
                            type="error"
                            message="내용을 확인하고 선택해 주세요"
                          />
                        </div>
                      </div>
                      <SatSelect
                        value={fpReport.satLpReport.sns.snsType}
                        title="SNS 활용 내용 선택"
                        options={[
                          { label: '고객발굴', value: '고객발굴' },
                          { label: '고객관리', value: '고객관리' },
                          { label: '고객근황파악', value: '고객근황파악' },
                          { label: '기타', value: '기타' },
                        ]}
                        onChange={value =>
                          onChangeFpReport(
                            'satLpReport',
                            'snsType',
                            value.value,
                          )
                        }
                        customStyleClass="w-200 mgb-16"
                      />
                    </>
                  )}
                </div> */}
                {/* 3번 항목 */}
                {/* <div className="infor-list">
                  <div className="insu-box">
                    <div className="txt-question">
                      <p>{`3. 보험가입동기를 선택해주세요. (복수 선택 가능합니다.)`}</p>
                      <SatValidationErrMsg
                        visible={
                          isCheckError &&
                          fpReport.satLpReport.joinMotivation.length === 0
                        }
                        type="error"
                        message="내용을 확인하고 선택해 주세요"
                      />
                    </div>
                  </div>
                  <div className="check-box w100">
                    <SatCheckBox
                      value={fpReport.satLpReport.joinMotivation}
                      options={motivateList()}
                      onChange={value =>
                        onChangeFpReport('satLpReport', 'joinMotivation', value)
                      }
                    />
                  </div>
                </div> */}
                {/* 4번 항목 */}
                {/* <div className="infor-list">
                  <div className="insu-box">
                    <div className="txt-question">
                      <p>{`4. 가망고객소개여부를 선택해주세요.`}</p>
                      <SatValidationErrMsg
                        visible={
                          isCheckError && fpReport.satLpReport.recommend === ''
                        }
                        type="error"
                        message="내용을 확인하고 선택해 주세요"
                      />
                    </div>
                  </div>
                  <div className="check-box w100">
                    <SatRadio
                      name="recommend"
                      value={fpReport.satLpReport.recommend}
                      options={[
                        { label: '3명', value: '3명' },
                        { label: '1~2명', value: '1~2명' },
                        { label: '0명', value: '0명' },
                      ]}
                      onChange={value =>
                        onChangeFpReport(
                          'satLpReport',
                          'recommend',
                          value.value,
                        )
                      }
                    />
                  </div>
                </div> */}
                {/* 5번 항목 */}
                {/* <div className="infor-list">
                  <div className="insu-box">
                    <div className="txt-question">
                      <p>{`5. 판매시장 구분을 해주세요.`}</p>
                      <SatValidationErrMsg
                        visible={
                          isCheckError &&
                          fpReport.satLpReport.salesMarket === ''
                        }
                        type="error"
                        message="내용을 확인하고 선택해 주세요"
                      />
                    </div>
                  </div>
                  <div className="check-box w100">
                    <SatRadio
                      name="salesMarket"
                      value={fpReport.satLpReport.salesMarket}
                      options={[
                        { label: 'X시장', value: 'X시장' },
                        { label: 'Y시장', value: 'Y시장' },
                        { label: 'Z시장', value: 'Z시장' },
                        { label: '감사고객', value: '감사고객' },
                      ]}
                      onChange={value =>
                        onChangeFpReport(
                          'satLpReport',
                          'salesMarket',
                          value.value,
                        )
                      }
                    />
                  </div>
                </div> */}
                {/* 6번 항목 */}
                {/* <div className="infor-list">
                  <div className="insu-box">
                    <div className="txt-question">
                      <p>{`6. 청약시까지의 Activity 진행 횟수를 선택해주세요.`}</p>
                    </div>
                  </div>
                  <div className="txt-question mgb-16">
                    <p>{`6-1. AP/FF`}</p>
                    <SatValidationErrMsg
                      visible={
                        isCheckError && fpReport.satLpReport.activity.ap === ''
                      }
                      type="error"
                      message="내용을 확인하고 선택해 주세요"
                    />
                  </div>
                  <div className="check-box w100">
                    <SatRadio
                      name="activityAp"
                      value={fpReport.satLpReport.activity.ap}
                      options={[
                        { label: '1회', value: '1회' },
                        { label: '2회', value: '2회' },
                        { label: '3회', value: '3회' },
                        { label: '4회', value: '4회' },
                        { label: '5회 이상', value: '5회 이상' },
                        { label: '없음', value: '없음' },
                      ]}
                      onChange={value =>
                        onChangeFpReport(
                          'satLpReport',
                          'activityAp',
                          value.value,
                        )
                      }
                    />
                  </div>
                  <div className="txt-question mgb-16">
                    <p>{`6-2. PR/CL`}</p>
                    <SatValidationErrMsg
                      visible={
                        isCheckError && fpReport.satLpReport.activity.pr === ''
                      }
                      type="error"
                      message="내용을 확인하고 선택해 주세요"
                    />
                  </div>
                  <div className="check-box w100">
                    <SatRadio
                      name="activityPr"
                      value={fpReport.satLpReport.activity.pr}
                      options={[
                        { label: '1회', value: '1회' },
                        { label: '2회', value: '2회' },
                        { label: '3회', value: '3회' },
                        { label: '4회', value: '4회' },
                        { label: '5회 이상', value: '5회 이상' },
                        { label: '없음', value: '없음' },
                      ]}
                      onChange={value =>
                        onChangeFpReport(
                          'satLpReport',
                          'activityPr',
                          value.value,
                        )
                      }
                    />
                  </div>
                </div> */}
                {/* 7번 항목 */}
                {/* <div className="infor-list">
                  <div className="insu-box">
                    <div className="txt-question">
                      <p>{`7. 청약시 어려웠던점을 선택해주세요.`}</p>
                      <SatValidationErrMsg
                        visible={
                          isCheckError && fpReport.satLpReport.difficulty === ''
                        }
                        type="error"
                        message="내용을 확인하고 선택해 주세요"
                      />
                    </div>
                  </div>
                  <div className="check-box w100">
                    <SatRadio
                      name="difficulty"
                      value={fpReport.satLpReport.difficulty}
                      options={difficultyList}
                      onChange={value =>
                        onChangeFpReport(
                          'satLpReport',
                          'difficulty',
                          value.value,
                        )
                      }
                    />
                  </div>
                </div> */}
                {/* 8번 항목 */}
                {/* <div className="infor-list">
                  <div className="insu-box">
                    <div className="txt-question">
                      <p>{`7. 계약자의 연수입을 선택해주세요.`}</p>
                      <SatValidationErrMsg
                        visible={
                          isCheckError && fpReport.satLpReport.salary === ''
                        }
                        type="error"
                        message="내용을 확인하고 선택해 주세요"
                      />
                    </div>
                  </div>
                  <SatSelect
                    value={fpReport.satLpReport.salary}
                    title="연수입 선택"
                    options={salaryList}
                    onChange={value =>
                      onChangeFpReport('satLpReport', 'salary', value.value)
                    }
                    customStyleClass="w-200 mgb-16"
                  />
                </div> */}
                {/* 9번 항목 */}
                {/* <div className="infor-list">
                  <div className="insu-box">
                    <div className="txt-question">
                      <p>{`8. 계약자의 가족구성을 선택해주세요.`}</p>
                    </div>
                  </div>
                  <div className="insu-box">
                    <div className="txt-question">
                      <p>{`8-1. 결혼여부`}</p>
                      <SatValidationErrMsg
                        visible={
                          isCheckError &&
                          fpReport.satLpReport.family.marriage === ''
                        }
                        type="error"
                        message="내용을 확인하고 선택해 주세요"
                      />
                    </div>
                  </div>
                  <div className="check-box w100">
                    <SatRadio
                      name="marriage"
                      value={fpReport.satLpReport.family.marriage}
                      options={[
                        { label: '미혼', value: '미혼' },
                        { label: '기혼', value: '기혼' },
                      ]}
                      onChange={value =>
                        onChangeFpReport('satLpReport', 'marriage', value.value)
                      }
                    />
                  </div>
                  {fpReport.satLpReport.family.marriage === '기혼' && (
                    <>
                      <div className="insu-box">
                        <div className="txt-question">
                          <p>{`8-2. 기혼인경우 자녀수`}</p>
                          <SatValidationErrMsg
                            visible={
                              isCheckError &&
                              fpReport.satLpReport.family.marriage &&
                              fpReport.satLpReport.family.child === ''
                            }
                            type="error"
                            message="내용을 확인하고 선택해 주세요"
                          />
                        </div>
                      </div>
                      <div className="check-box w100">
                        <SatRadio
                          name="child"
                          value={fpReport.satLpReport.family.child}
                          options={[
                            { label: '자녀 없음', value: '자녀 없음' },
                            { label: '자녀 1명', value: '자녀 1명' },
                            { label: '자녀 2명', value: '자녀 2명' },
                            { label: '자녀 3명이상', value: '자녀 3명이상' },
                          ]}
                          onChange={value =>
                            onChangeFpReport(
                              'satLpReport',
                              'child',
                              value.value,
                            )
                          }
                        />
                      </div>
                    </>
                  )}
                </div> */}
                {/* 10번 항목 */}
                <div className="infor-list">
                  <div className="insu-box mgb-0">
                    <div className="txt-question">
                      <p>{`2. 면담정보를 작성해주세요.`}</p>
                    </div>
                  </div>
                  <div className="insu-box item-r mgt-0">
                    <table className="medi-history mgt-10">
                      <caption>{`정보선택`}</caption>
                      <colgroup>
                        <col style={{ width: '10rem' }} />
                        <col />
                      </colgroup>
                      <tbody>
                        <tr>
                          <th scope="row">{`피대면자 성명`}</th>
                          <td>
                            {omniYn === 'Y' && $utils.checkLPText(userType) ? (
                              <SatInput
                                value={ownerName}
                                type="text"
                                readOnly
                              />
                            ) : (
                              <>
                                <SatFollowText
                                  ref={followRef}
                                  followText={ownerName}
                                  onMatched={handleMatched}
                                  complete={complete}
                                />
                                <p className="text-info ico-type block">
                                  {`계약자 성명과 동일하지 않은 경우, 진행 불가`}
                                </p>
                                <SatValidationErrMsg
                                  visible={
                                    isCheckError &&
                                    !followRef.current.getIsMatched()
                                  }
                                  type="error"
                                  message="내용을 확인하고 선택해 주세요"
                                />
                              </>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" className="v-middle">{`대면일자`}</th>
                          <td>
                            <SatDatePicker
                              size="small"
                              value={
                                fpReport.interview.owner.interviewDate ||
                                subscriptionDate
                              }
                              filterDate={date => {
                                return subscriptionDate
                                  ? isBeforeDay(
                                      date,
                                      parse(
                                        subscriptionDate,
                                        'yyyyMMdd',
                                        new Date(),
                                      ),
                                    )
                                  : true;
                              }}
                              disabled={
                                omniYn === 'Y' && $utils.checkLPText(userType)
                              }
                              onChange={date =>
                                onChangeFpReport(
                                  'interview',
                                  'interviewDate',
                                  date,
                                )
                              }
                              disabledDates={[
                                addDates(
                                  subscriptionDate || getToday('yyyyMMdd'),
                                  'month',
                                  -1,
                                  'yyyyMMdd',
                                ),
                                subscriptionDate || getToday('yyyyMMdd'),
                              ]}
                            />
                            <SatValidationErrMsg
                              visible={
                                isCheckError &&
                                fpReport.interview.owner.interviewDate === ''
                              }
                              type="error"
                              message="내용을 확인하고 선택해 주세요"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{`대면장소`}</th>
                          <td>
                            <SatInput
                              ref={placeInputRef}
                              value={fpReport.interview.owner.interviewPlace}
                              placeholder="장소 입력 (예: 역삼동 커피숍)"
                              onChange={value =>
                                onChangeFpReport(
                                  'interview',
                                  'interviewPlace',
                                  value,
                                )
                              }
                              readOnly={
                                omniYn === 'Y' && $utils.checkLPText(userType)
                              }
                              validGuide={{
                                fixed: true,
                                guideMsg:
                                  '대면장소는 읍/면/동 행정구역명과 장소를 입력해주세요.',
                              }}
                              validRule={[
                                {
                                  required: true,
                                  errMsg:
                                    '대면장소는 읍/면/동 행정구역명과 장소를 입력해주세요.',
                                },
                              ]}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="info-box bg-yellow">
                    <p className="text-info3">
                      {`위 사항을 공정 성실히 면담 기재 하였으므로 이에 관한 보고상
                  일체의 책임을 질 것을 서약하며 점검한 후 이상 없음을
                  확인합니다.`}
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <EaBottom
        label="작성완료"
        onClick={checkIsValidBtn}
        isDisabled={!isConfirm}
      />
    </>
  );
};

export default AppReportInterview;
